import { createFileRoute, redirect } from "@tanstack/react-router";

/** @public */
export const Route = createFileRoute("/_auth/messages/")({
    beforeLoad: () => {
        throw redirect({ to: "/messages/inbox" });
    },
});
